import script from "./FamilyDetailsPageView.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyDetailsPageView.vue?vue&type=script&setup=true&lang=js"

import "./FamilyDetailsPageView.vue?vue&type=style&index=0&id=24bf4405&lang=scss"

const __exports__ = script;

export default __exports__